import { Permission, Role } from '../enum';

const permissionsByRole: { [permission: string]: Role[] } = {
  [Permission.ViewDocumentStatus]: [
    Role.FullAdmin,
    Role.RestrictedAdmin,
    Role.User,
  ],
  [Permission.ManageFolders]: [Role.FullAdmin, Role.RestrictedAdmin, Role.User],
  [Permission.ManageMainFolders]: [Role.FullAdmin, Role.RestrictedAdmin],
  [Permission.DeleteFolder]: [Role.FullAdmin, Role.RestrictedAdmin],
  [Permission.UploadDocuments]: [
    Role.FullAdmin,
    Role.RestrictedAdmin,
    Role.User,
  ],
  [Permission.ChangeDocumentStatus]: [Role.FullAdmin, Role.RestrictedAdmin],
  [Permission.DeleteDocument]: [Role.FullAdmin, Role.RestrictedAdmin],
  [Permission.CopyFolder]: [Role.FullAdmin, Role.RestrictedAdmin, Role.User],
  [Permission.CreateFullAdmin]: [Role.FullAdmin],
};

export const getPermissions = (role: Role): Permission[] =>
  Object.entries(permissionsByRole).flatMap(([permission, roles]) =>
    roles.includes(role) ? (permission as Permission) : []
  );
